import axios from 'axios'
import { Notification, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { Script } from 'vm'
import Config from '@/config'

// 创建axios实例、配置baseURL、超时时间
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 50000 // 请求超时时间
})

// const CancelToken = service.CancelToken;

// request拦截器
service.interceptors.request.use(
  config => {
    // config.cancelToken = new CancelToken(function (cancel) {
    //   console.log(cancel)
    //   store.commit('pushToken', {cancelToken: cancel})
    // })
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message
      })
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    const code = error.response.data.status
    if (code === 403 || code === 401) {
      if(localStorage.getItem('language') == 'en'){
        MessageBox.confirm(
          'To protect the security of your account, please login again',
          'Tips',
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning',
            cancelButtonClass: 'messageBox-btnFEN',
            confirmButtonClass: 'messageBox-btnTEN',
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }else if(localStorage.getItem('language') == 'zh'){
        MessageBox.confirm(
          '为了保护您的账号安全，请重新登录',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
    } else {
      const errorMsg = error.response.data.message
      if (errorMsg !== undefined) {
        Notification.error({
          title: errorMsg,
          duration: 2500
        })
      }
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js